import { Err, ErrorCode, Storage } from "@pentacode/core";
// @ts-expect-error - no type declarations for localforage source import
import localforage from "localforage/src/localforage";

const store = localforage.createInstance({ name: "pentacode" });

export class LocalStorage extends Storage {
    // TODO(PTC-4250): remove legacy migration in versions > 1.49.3
    constructor(private readonly migrateLegacy = true) {
        super();
    }

    async _set(key: string, value: string) {
        await store.setItem(key, value);
    }

    async _get(key: string) {
        const data = ((await store.getItem(key)) as string) || (await this._migrate(key));
        if (!data) {
            throw new Err(ErrorCode.NOT_FOUND);
        }
        return data;
    }

    async _delete(key: string) {
        await store.removeItem(key);
    }

    async clear() {
        await store.clear();
    }

    // TODO(PTC-4250): remove legacy migration in versions > 1.49.3
    private async _migrate(key: string) {
        if (!this.migrateLegacy) {
            return null;
        }
        const data = (await localforage.getItem(key)) as string | null;
        if (data) {
            await store.setItem(key, data);
            await localforage.removeItem(key);
        }
        return data;
    }
}
